export default {
    locale: 'de',
    messages: {
        actions: 'Aktionen',
        add: 'Hinzufügen',
        addressAddNew: 'Füge eine neue Adresse hinzu',
        addressChangeAddress: 'Wählen Sie eine andere Adresse',
        addressCity: 'Stadt',
        addressCountry: 'Land',
        addressDeleteConfirmMessage: 'Möchten Sie diese Adresse wirklich löschen?',
        addressDeleteConfirmTitle: 'Adresse löschen',
        addressDeleteSuccess: 'Adresse gelöscht!',
        addressEdit: 'Adresse bearbeiten',
        addressesMyManage: 'Verwalten Sie meine Adressen',
        addressInvoice: 'Rechnungsadresse',
        addressInvoiceCountry: 'Land der Rechnungsadresse',
        addressInvoiceSameAsShippingLabel: 'Sind die Rechnungsdaten mit den Lieferdaten identisch?',
        addressInvoiceUsedFor: 'Als Rechnungsadresse definiert',
        addressInvoiceUsedForSuccess: 'Rechnungsadresse aktualisiert!',
        addressLabel: 'Titel Adresse',
        addressMy: 'Meine Adressen',
        addressMyViewButton: 'Siehe meine Adressen',
        addressName: 'Empfänger',
        addressNameAlt: 'Firmenname (bei Lieferung zur Arbeit)',
        addressNoItems: 'Sie haben noch keine Adresse registriert!',
        addressPhone: 'Telefon (wichtig für die Lieferung)',
        addressPostalCode: 'Postleitzahl',
        addressRegion: 'Abteilung',
        addressSavedCountryError: 'Dieses Land ist nicht erlaubt!',
        addressSavedSuccess: 'Adresse gespeichert!',
        addressSelectOptions: 'Wählen Sie eine Adresse',
        addressShipping: 'Lieferadresse',
        addressShippingCountry: 'Land der Zustellung',
        addressStreet1: 'Strasse und Hausnummer',
        addressStreet2: 'Wohnungsnummer, digitaler Code, Gegensprechanlage, ...',
        addressUserCount: `Sie haben {count} {count, plural,
            =0 {}
            =1 {}
            other {}
        }`,
        administrationTitle: 'Verwaltung',
        alertFetchApiError: 'Der Server ist derzeit ausser Betrieb ...',
        alertFormRequiredFieldsError: 'Bitte füllen Sie alle Pflichtfelder aus !',
        alertGenericError: 'Ein Fehler ist aufgetreten ! Bitte versuchen Sie es später ...',
        alertJsonParseError: 'Der Server hat eine falsche Antwort zurückgegeben ...',
        alertUnauthorized: 'Ihre Sitzung ist abgelaufen! Bitte wieder neu verbinden',
        alertContactError: 'Nachricht kann nicht gesendet werden! Versuchen Sie es noch einmal...',
        alertContactSuccess: 'Ihre Nachricht wurde erhalten',
        alertUserAlreadyExists: 'Mit dieser E-Mail-Adresse existiert bereits ein Konto!',
        alertUserRegisterSuccess: 'Herzlich willkommen ! Bitte melden Sie sich mit Ihrem temporären Passwort an, das Sie in Ihrer {user} Mailbox erhalten haben',
        app404ErrorTitle: 'Falsche Straße ...',
        appAccessButton: 'Gehen Sie zu {app}',
        appConditionsAcceptTitle: 'Allgemeine Geschäftsbedingungen',
        appConditionsCheckError: 'Bitte klicken Sie auf die allgemeinen Geschäftsbedingungen zur Zustimmung!',
        appConditionsCheckLabel: 'Ich habe die allgemeinen Geschäftzbedinungen gelesen und akzeptiere sie',
        appConditionsCheckSuccess: 'Gut erhalten !',
        appConditionsUpdateDate: 'Aktualisiert am {Datum}',
        appCookieConsentText: 'Wenn Sie weiterhin auf dieser Website bleiben, akzeptieren Sie die Verwendung von Cookies für das ordnungsgemäße Funktionieren des gratis Dienstes und der Statistiken. Ohne Ihre vorherige Zustimmung werden keine personenbezogenen Daten übermittelt.',
        appCookieConsentPrivacyLink: 'Siehe unsere Datenschutzbestimmungen',
        appForceUpdateApp: 'Aktualisierung der Anwendung erzwingen',
        appAdvantagesFabrication: 'In Europa hergestellt',
        appAdvantagesFreeShipping: 'Kostenlose Lieferung in Europa',
        appAdvantagesInternationalShipping: 'Internationale Lieferung',
        appAdvantagesSecurePayment: 'Sichere Bezahlung',
        appVersionCurrent: 'Aktuelle Version der Anwendung: {version}',
        back: 'Zurück',
        by: 'durch',
        cancel: 'Annulieren',
        cartAddToButton: 'In den Warenkorb legen',
        cartBackToHomeButton: 'Fahren Sie auf der Website fort',
        cartConfirmationText: 'Sie erhalten eine Bestätigungs-E-Mail. <br /> Ihre Bestellung wird angezeigt und Sie können sie über <a href="{link}"> Ihr Konto </a> verfolgen.',
        cartConfirmationTitle: 'Vielen Dank! <br /> Ihre Bestellung <a href="{link}" class="text-warning text-underline">{orderNumber}</a> wurde erfolgreich registriert.',
        cartConfirmationSubText: 'Kommen Sie und tauschen Sie sich auf unseren sozialen Netzwerken aus',
        cartDeliveryTitle: 'Lieferung',
        cartEmptyError: 'Ihr Warenkorb ist leer...',
        cartInvoiceAddressSelectionTitle: 'Wählen Sie Ihre Rechnungsadresse',
        cartItemProductPackPriceAlertTitle: 'Sinkende Staffelpreise',
        cartItemProductPackPriceAlertText: 'Erhöhen Sie die Anzahl der Flaschen, für niedrigere Staffelpreise',
        cartLegalMentionText: 'Mit der Bestätigung Ihrer Bestellung bestätigen Sie, dass Sie die <a href="{link}" target="_blank">AGB</a> gelesen haben und die Bedingungen akzeptieren',
        cartNextButton: 'Weiter',
        cartNotValidError: 'Bitte überprüfen Sie Ihren Warenkorb, bevor Sie fortfahren!',
        cartPayButton: 'Zur Zahlung',
        cartPaymentBankTransferLabel: 'Ich bezahle per Überweisung',
        cartPaymentCreditCardLabel: 'Ich bezahle mit Kreditkarte',
        cartPaymentPaypalLabel: 'Ich bezahle mit Paypal',
        cartPendinpPaymentText: 'Wir warten nur auf Ihre Zahlung, um Ihre Bestellung zu bearbeiten ...',
        cartStepPaymentTitle: 'Ihre Bezahlung',
        cartStepPaymentInfoText: 'Gut gemacht, wir sind fast fertig! <br /> Geben Sie Ihre Zahlungsmethode ein.',
        cartStepPreviewTitle: 'Ihr Warenkorb',
        cartStepPreviewInfoText: 'Sie befinden sich in Ihrem Warenkorb. <br /> Beachten Sie an unsere sinkenden Staffelpreise.',
        cartStepShippingTitle: 'Ihre Kontaktdaten',
        cartStepShippingInfoText: 'Überprüfen Sie Ihre Lieferadresse mit Detailinformationen<br /> für eine Problemlose Zustellung',
        cartShippingAddressMissingError: 'Sie haben Ihre Lieferadresse nicht eingegeben!',
        cartShippingAddressSelectionTitle: 'Wählen Sie Ihre Lieferadresse',
        cartShippingCalculatedTitle: 'Versand und Mehrwertsteuer',
        cartShippingCalculationText: 'Geben Sie das Land ein, in welches geliefert werden soll.  ',
        cartShippingCalculationTitle: 'Berechnen Sie Ihre Versandkosten und Mehrwertsteuer. ',
        cartShippingCalculationListButton: 'Lieferland',
        cartShippingSetAlert: 'Sie möchten, dass es nach {country} geliefert wird',
        cartShippingUnavailableAlert: 'Wir können nicht in Ihre Region liefern!',
        cartShippingUnavailableLink: 'Siehe Liste der Länder',
        cartShippingValidateDetails: 'Überprüfen Sie die Lieferdetails',
        cartTotalNotSet: 'Unzutreffend',
        cartTotalShipping: 'Versand',
        cartTotalShippingFree: 'Kostenlos',
        cartTotalSubTotal: 'Zwischensumme',
        cartTotalTax: 'MwSt',
        cartTotalTotal: 'Gesamt',
        cartVoucherApplyTitle: 'Gutschein-Code',
        checkToggler: 'Alle auswählen / abwählen',
        choose: 'Wählen',
        close: 'Schließen',
        cms: 'CMS',
        cmsContentEdit: 'Bearbeitung von Inhalten',
        cmsContentIsActive: 'Inhalt aktiviert?',
        cmsContentModelLabel: 'Modell',
        cmsContentSlug: 'Zugriffspfad',
        cmsContentTitle: 'Überschrift',
        cmsContentTranslations: 'Übersetzungen',
        cmsContentTypeLabel: 'Inhaltstyp',
        cmsPageSeoDescription: 'SEO Beschreibung',
        cmsPageSeoKeywords: 'SEO Schlüsselwörter',
        cmsPageSeoTitle: 'SEO Titel',
        cmsPanelIsTemplate: 'Im Thema enthalten',
        configuration: 'Konfiguerierung',
        contactByEmail: 'Per E-Mail',
        contactFormIdentityTitle: 'Kontaktdaten',
        contactInfoText: 'Bei Fragen zu unserem Produkt oder Ihrer Bestellung',
        contactMessage: 'Anfrage',
        contactNeedHelpTitle: 'Brauchen Sie Hilfe ?',
        contactPageButton: 'Senden',
        contactPageTitle: 'Kontaktieren Sie uns',
        contactPageText1: 'Brauchen Sie Hilfe ? Informationen? Wir sind hier, um dir zu helfen !',
        contactSendButton: 'Die Nachricht absenden',
        contactTitle: 'Kontakt',
        contactUsByPhone: 'kontaktieren Sie uns unter',
        continue: 'Weiter verfolgen',
        country: 'Land',
        countryFillPlaceholder: 'Geben Sie ein Land ein und drücken Sie die Eingabetaste',
        countrySelectPlaceholder: 'Wähle ein Land',
        dateActivated: 'Aktivierungs-Datum',
        dateCreated: 'Erstellungsdatum',
        dateCreation: 'Erstellungsdatum',
        dateLastCguAccept: 'Datum der letzten Validierung der AGB',
        dateLastEdit: 'Datum der letzten Änderung',
        dateLastLogin: 'Datum der letzten Verbindung',
        dateLastOrder: 'Datum der letzten Bestellung',
        dateSelect: 'Wählen Sie ein Datum',
        dateSelectPlaceholder: 'Klicken Sie hier, um ein Datum auszuwählen ...',
        dashboardTitle: 'Instrumententafel',
        date: 'Datum',
        dateThe: 'Am (Datum}',
        days: 'Tag(e)',
        delete: 'Entfernen',
        deleteRequestError: 'Löschfehler!',
        deleteRequestSuccess: 'Gelöscht!',
        domain: 'Feld',
        download: 'Herunterladen',
        edit: 'Bearbeiten',
        editViewAdvanced: 'Für fortgeschrittene Bearbeitung',
        editViewSimplified: 'Vereinfachte Bearbeitung',
        elementsCount: '{count} elemete(n)',
        elementNoItems: 'Keine Produkte',
        example: 'Beispiel',
        examples: 'Beispiele',
        file: 'Datei',
        fileDeleteError: 'Diese Datei kann nicht gelöscht werden',
        fileDeleteSuccess: 'Datei gelöscht!',
        files: 'Dateien',
        fileUploadError: 'Diese Datei kann nicht geladen werden!',
        fileUploadProcessStartOnSave: 'Das Laden der Datei beginnt beim Speichern.',
        fileUploadSuccess: 'Datei hochgeladen!',
        fileUploadRestrictionTypeError: 'Dateiformat nicht akzeptiert! Erlaubt: {Typen}',
        filtersTitle: 'Filter',
        finish: 'Beendigen',
        formFieldRequired: 'Dies ist ein Pflichtfeld!',
        formFieldValidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein !',
        generalInformation: 'Allgemeine Informationen',
        help: 'Hilfe',
        hours: 'Stunden',
        imageDeleteError: 'Dieses Bild kann nicht gelöscht werden!',
        imageDeleteSuccess: 'Bild gelöscht!',
        imageUploadError: 'Dieses Bild konnte nicht geladen werden',
        imageUploadRestrictionSize: 'Das Bild muss ein Format von maximal {format} haben',
        imageUploadRestrictionType: 'Das Bild muss in {types} sein',
        imageUploadRestrictionTypeError: 'Bildformat nicht akzeptiert! Erlaubt: {Typen}',
        import: 'Importieren',
        importerFileInfo: 'Wählen Sie eine CSV-Datei aus (Werte durch Kommas getrennt)',
        importerFileHelp: 'Sie können eine CSV-Datei mit Ihrer Tabellenkalkulationssoftware (Excel, OpenOffice, ...) erstellen.',
        importerNoItemsAlert: 'Keine zu importierenden Artikel',
        importerTitle: 'Daten importieren',
        importerFileButton: 'Importieren Sie die Daten',
        importModelDownloadButton: 'Laden Sie die Vorlage herunter',
        importRequestError: 'Beim Import ist ein Fehler aufgetreten!',
        importRequestSomeFailAlert: 'Ein oder mehrere Einträge konnten nicht importiert werden!',
        importRequestSuccess: 'Daten importiert!',
        information: 'Information',
        informationsDetails: 'Einzelheiten',
        informationsGeneral: 'Allgemeine Informationen',
        isActive: 'Aktiv?',
        isPublic: 'Öffentlichkeit?',
        isUnlimited: 'Unbegrenzt?',
        label: 'Berechtigt',
        langDE: 'Deutsh',
        langEN: 'English',
        langES: 'Español',
        langFR: 'Français',
        language: 'Sprache',
        learnMore: 'Finde mehr heraus',
        listTitle: 'Auflistung',
        loading: 'Wird geladen...',
        loadMore: 'Mehr laden ...',
        logo: 'Logo',
        matter: 'Material',
        minutes: 'Protokoll)',
        name: 'Nachname',
        next: 'folgenden',
        newsletterInfoText: 'Möchten Sie mehr wissen? Abonnieren Sie unseren Newsletter',
        newsletterTitle: 'Newsletter',
        no: 'Nein',
        options: 'Optionen',
        orderAdd: 'Bestellung hinzufügen',
        orderBuyButton: 'Kaufen',
        orderCartLink: 'Korb',
        orderCreationError: 'Wir können Ihre Bestellung momentan nicht erstellen ... Bitte kontaktieren Sie uns!',
        orderCreationProcessing: 'Wir erstellen Ihre Bestellung ...',
        orderFlags: 'Flaggen',
        orderInformationDetails: 'Bestellung',
        orderInvoice: 'Rechnung',
        orderInvoiceDate: 'Abrechnungsdatum',
        orderInvoiceNumber: 'Rechnungsnummer',
        orderItems: 'Inhalt',
        orderMy: 'Meine Bestellung',
        ordersMyViewButton: 'Siehe meine Bestellungen',
        ordersMy: 'Meine Bestellungen',
        orderNoElements: 'Du hast noch nicht bestellt!',
        orderPaymentChooseMethodLabel: 'Wählen Sie eine Zahlungsmethode',
        orderPaymentFinishTitle: 'Setzen Sie meine Zahlung fort',
        orderPaymentMethod: 'Zahlungsmethode',
        orderPaymentMethodBanktransfer: 'Banküberweisung',
        orderPaymentMethodCreditcard: 'Kreditkarte',
        orderPaymentMethodPaypal: 'Paypal',
        orderPaymentPaypalHelp: 'Klicken Sie auf diese Taste um mit Paypal zu bezahlen',
        orderPaymentProcessButton: 'Eine Zahlung tätigen',
        orderPaymentProcessing: 'Wir erheben Daten für Ihre Zahlung...',
        orderPayments: 'Zahlungen',
        orderPaymentStatusPending: 'Warten',
        orderPaymentStatusComplete: 'Fertig',
        orderPaymentUnavailableAlert: 'Zahlungsmethode nicht verfügbar ... Bitte kontaktieren Sie uns, um Ihre Zahlung vorzunehmen.',
        orderPaymentValidButton: 'Ich bestätige Zahlung',
        orderPaymentValidSuccess: 'Zahlung bestätigt',
        orderProductAdd: 'Fügen Sie ein Produkt hinzu',
        orderReOrderButton: 'Erneuere meine Bestellung',
        orders: 'Aufträge',
        orderShippings: 'Expeditionen',
        orderStatusArchived: 'Archiviert',
        orderStatusCanceled: 'Abgesagt',
        orderStatusComplete: 'Fertig',
        orderStatusOnpreparation: 'In Vorbereitung für',
        orderStatusPendingpayment: 'Warten auf Zahlung',
        orderStatusShipped: 'Versand',
        orderSubscribeButton: 'Abonnieren',
        orderTotal: 'Gesamtbetrag',
        orderUserCount: `Sie haben {count} {count, plural,
            =0 {}
            =1 {}
            other {}
        }`,
        orderWeight: 'Bestellgewicht',
        Page404ErrorTitle: 'Sie haben nicht gefunden, wonach Sie suchen ...',
        priceHT: 'Preis ohne MwSt. ',
        priceTTC: 'Preis inkl. MwSt.',
        previous: 'Zurück',
        productAdd: 'Fügen Sie ein Produkt hinzu',
        productAddedSuccess: '{Produkt} hinzugefügt!',
        productCodeEAN: 'EAN-Code',
        productComposition: 'Zusammensetzung',
        productDescription: 'Beschreibung',
        productDuplicateSuccess: 'Produkt dupliziert!',
        productEdit: 'Produkt bearbeiten',
        productImageSaveBeforeAlert: 'Sie müssen dieses Produkt registrieren, bevor Sie ein Bild hinzufügen können!',
        productName: 'Nachname',
        productPackChoiceTitle: 'Entdecken Sie unsere Packs',
        productPackFreeCount: `+{count} {count, plural,
            =0 {Gratis}
            =1 {Gratis}
            other {Gratis}
        } {count, plural,
            =0 {Flasche}
            =1 {Flasche}
            other {Flaschen}
        }`,
        productPackMonthlyConsumptionLabel: 'Empfohlen für 1 Monat',
        productPackUnitPrice: '{price}/Flasche',
        productPriceInformation: 'Preise',
        products: 'Produkte',
        productSelectOptions: 'Wählen Sie ein Produkt',
        productSlug: 'Pfad',
        productSubTotal: 'Preis inkl. MwSt.',
        productTaxCalculate: 'Berechnung',
        productTaxRate: 'Steuersatz',
        productTaxRateTaxCalculation: 'Oder {Betrag} € Mehrwertsteuer',
        productUnitLabel: 'Flasche',
        productUnitCountLabel: `{count} {count, plural,
            =0 {Flasche}
            =1 {Flasche}
            other {Flaschen}
        }`,
        quantity: 'Quantität',
        refresh: 'Aktualisieren',
        remove: 'Entfernen',
        retry: 'Neustart',
        reviewAddFirstReviewButton: 'Meine Bewertung abgeben',
        reviewAddFirstReviewText: 'Gefällt dir unser Produkt? Möchten Sie Ihre Erfahrung mit unseren Kunden teilen? Teilen Sie Ihre Erfahrung! Es dauert nur 2 Minuten!',
        reviewAddFirstReviewTitle: 'Bewerten Sie unser Produkt!',
        reviewAddLoading: 'Wir registrieren Ihre Meinung in…',
        reviewAddSuccess: 'Wir haben Ihren Erfahrungsbericht erhalten! Er wird nach der Moderation angezeigt ....',
        reviewAnswer: 'Atremoplus-Antwort',
        reviewFilterLabel: 'Zeugnisse sortieren',
        reviewFilterLanguageLabel: 'Nach Sprache',
        reviewLink: 'Kopieren Sie den Link Ihres Videos',
        reviewLinkHelp: 'Speichern Sie Ihr Video beispielsweise auf Youtube und kopieren Sie den Videolink in das Feld oben.',
        reviewLinkViewButton: 'Siehe den Link',
        reviewName: 'Name und Land',
        reviews: 'Erfahrungsberichte',
        reviewScoreLabel: 'Wählen Sie die Note aus die Sie uns geben möchten',
        reviewSummaryButton: 'Entdecken Sie die Kundenstimmen',
        reviewSummaryTitle: 'Unsere Kunden sprechen am besten darüber, entdecken Sie ihre Erfahrungsberichte!',
        reviewText: 'Geben Sie Ihre Meinung ein ...',
        reviewTitle: 'Titel deiner Bewertung',
        reviewTypeLinkLabel: 'Medien',
        reviewTypeTextLabel: 'Texte',
        save: 'Registrieren',
        saveBeforeAlert: 'Bitte zuerst registrieren ...',
        saveRequestError: 'Registrierungsfehler!',
        saveRequestSuccess: 'Registriert !',
        saving: 'Registrierung…',
        searchFor: 'Suche',
        seconds: 'Sekunde(n)',
        selectAll: 'Alles anwählen',
        selectUnAll: 'alles abwählen',
        selectFile: 'Wählen Sie eine Datei aus',
        selectImage: 'Wählen Sie ein Bild aus',
        selectOptions: 'Wähle eine Option',
        seoTitle: 'L-Dopa Nahrungsergänzung natürlichen Ursprungs',
        shippingFeeAmountLabel: 'Betrag',
        shippingFeeCarrierLabel: 'Transportunternehmen',
        shippingFeeCountriesLabel: 'Ausgewählte Länder',
        shippingFeeExcludeDepartmentInfo: 'Trennen Sie die Codes durch ein Komma (,). Verwenden Sie * als Platzhalter.',
        shippingFeeExcludeDepartmentLabel: 'Auszuschließende Postleitzahlen',
        shippingFeeFreeThresholdInfo: 'Setzen Sie diesen Wert auf 0, um die kostenlose Lieferung zu deaktivieren',
        shippingFeeFreeThresholdLabel: 'Mindestmenge zu erreichen, um die kostenlose Lieferung anzuwenden',
        shippingFeeHasExcludeConditions: 'Mit Ausnahmen',
        shippingFees: 'Versandkosten',
        shippingFeeTrackingUrlInfo: 'Sie können die URL "{trackingNumber}" hinzufügen, um die Tracking-Nummer automatisch zu aktivieren.',
        shippingFeeTrackingUrlLabel: 'URL für das Tracking',
        status: 'Status',
        stepTitle: 'Schritt {Schritt}',
        subscription: 'Abonnement',
        subscriptionCartButton: 'Ich abonniere unverbindlich',
        subscriptionCartText: 'Denken Sie an das Abonnement: Wählen Sie Ihren Zeitraum, Ihr Pack, OHNE Verpflichtung und einfach zu abonnieren!',
        subscriptionResumeTitle: 'Ihr Abonnement',
        subscriptionResumeText: `Sie haben ein Abonnement von {count} {count, plural,
            =0 {Flasche}
            =1 {Flasche}
            other {Flaschen}
        } jede {period}`,
        subscriptionConfigurationPackTitle: 'Wahl des Packs',
        subscriptionConfigurationPeriodTitle: 'Wahl des Bestellintervalls',
        subscriptionConfigurationTitle: 'Konfigurieren Sie Ihr Abonnement',
        subscriptionCreateButton: 'Ich abonniere mich unverbindlich',
        subscriptionPeriod1Month: '1 Monat',
        subscriptionPeriod6Week: '6 Wochen',
        subscriptionPeriod2Month: '2 Monate',
        subscriptionRemoveButton: 'Ich möchte mich im Moment nicht abonnieren',
        subscriptionStopButton: 'Abonnement beenden',
        submit: 'einreichen',
        switch: 'Wechseln',
        switchLanguage: 'Sprache wechseln',
        tableMassActions: 'Gruppenaktionen',
        tableRefreshSuccessError: 'Synchronisationsfehler!',
        tableRefreshSuccessAlert: 'Synchronisiert!',
        tag: 'Stichwort',
        tags: 'Schlüsselwörter',
        tagFillPlaceholder: 'Geben Sie ein Schlüsselwort ein und drücken Sie die Eingabetaste...',
        taxes: 'Steuern',
        taxCountriesLabel: 'Ausgewählte Länder',
        taxHasCustomsFees: 'Zollgebühren ?',
        taxHasCustomsFeesInfo: 'Mit Zollgebühren',
        taxRate: 'MwSt',
        taxRateLabel: 'Steuersatz',
        taxThresholdLabel: 'Mindestbetrag für die Anwendung des Satzes',
        time: 'Stunde',
        timezone: 'Zeitzone',
        the: 'das',
        title: 'Überschrift',
        total: 'Gesamt',
        type: 'Art',
        unit: 'Einheit',
        user: 'Benutzer',
        userAccountDataProtection: 'Datenschutz',
        userAccountDataProtectionText1: 'Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Deshalb verpflichten wir uns, diese zu sichern und für einen angemessenen Zeitraum aufzubewahren, der für die ordnungsgemäße Durchführung von Prüfungen erforderlich ist.',
        userAccountDataProtectionText2: 'Wir bitten Sie nur um Informationen, die für die Dienstleistung erforderlich sind, und wir verpflichten uns, niemals ohne Ihre Zustimmung an einen Dienst Dritter zu kommunizieren oder Ihre persönlichen Daten für kommerzielle Zwecke zu verwenden.',
        userAccountDataProtectionText3: 'Wenn Sie Ihre Daten zurückerhalten wollen oder Ihr Recht auf Datenübertragbarkeit nutzen möchten, kontaktieren Sie uns bitte unter {email}',
        userAccountDelete: 'Löschen Sie mein Konto',
        userAccountDeleteBlockText: 'Sie können Ihr Konto momentan nicht löschen!',
        userAccountDeleteButton: 'Löschen Sie mein Konto',
        userAccountDeleteConfirmMessage: 'Möchten Sie Ihr Konto wirklich dauerhaft löschen?',
        userAccountDeleteConfirmTitle: 'Löschen Sie mein Konto',
        userAccountDeleteError: 'Ihr Konto kann nicht gelöscht werden!',
        userAccountDeleteSuccess: 'Ihr Konto wurde gelöscht! Bis bald !',
        userAccountDeleteText: 'Durch das Löschen Ihres Kontos löschen Sie Ihren Zugriff auf Ihre Informationen auf dieser Website. Wir werden Ihre persönlichen Daten aus unserer Datenbank löschen. Diese Aktion ist irreversibel!',
        userAccoutDetailsTitle: 'Ihre Kontaktdaten',
        userAccountEdit: 'Ich möchte mein Konto ändern',
        userAccountEditSuccess: 'Konto aktualisiert',
        userAccountExistTitle: 'Haben Sie bereits ein Konto?',
        userAccountHistory: 'Historische Daten',
        userAccountInfo: 'Ihre Daten werden nicht veröffentlicht!',
        userAccountInfoMyTitle: 'Meine Information',
        userAccountGeneral: 'Allgemeines',
        userAccountMy: 'Mein Konto',
        userAccountPersonnalInformation: 'Meine persönlichen Informationen',
        userAccountPreferencesInformation: 'Meine Präferenzen',
        userAccountResetError: 'Fehler beim Initialisieren des Kontos!',
        userAccountResetSuccess: 'Konto re-initialisiert!',
        userActivityOnLine: 'Online',
        userAdd: 'Nutzer hinzufügen',
        userAddNew: 'Neuen Benutzer hinzufügen',
        userChangePasswordSuccess: 'Passwort geändert!',
        userConfirmationCode: 'Bestätigungscode per E-Mail erhalten',
        userConfirmationCodeCheckButton: 'Ich habe den Code zur Veränderung meines Passworts erhalten',
        userConfirmationCodeError: 'Bitte geben Sie den Bestätigungscode ein! Überprüfen Sie Ihre Mailbox!',
        userConnectionInfo: 'Greifen Sie auf Ihr Konto zu, um Ihre Bestellung zu bestätigen und Ihre Freunde zur Teilnahme einzuladen!',
        userCustomerAccountLink: 'Kundenkonto',
        userCustomerNewSubTitle: 'Kontaktdaten und Kundenkonto',
        userCustomerNewTitle: 'Neukunde ?',
        userCustomerRegisteredSubTitle: 'Anmeldung',
        userCustomerRegisteredTitle: 'Bereits Kunde',
        userDeleteConfirmation: '{user} wurde gelöscht!',
        userEdit: 'Benutzer bearbeiten}',
        userEdit2: 'Benutzer bearbeiten',
        userEditPassword: 'Mein Passwort ändern',
        userEmail: 'E-Mail-Adresse',
        userEmailError: 'Ihre Emailadresse ist ungültig!',
        userEmailFillInfo: 'Geben Sie Ihre E-Mail-Adresse ein',
        userEmailFormInfo: 'Geben Sie Ihre E-Mail-Adresse ein, um fortzufahren',
        userEmailSwitch: 'E-Mail Adresse ändern',
        userFillPlaceholder: 'Geben Sie den Benutzernamen ein ...',
        userFirstName: 'Vorname',
        userForgotPassword: 'Passwort vergessen ?',
        userForgotPasswordRetryDateError: 'Sie können kein Passwort erneut anfordern. Bitte überprüfen Sie Ihren E-Mail-Posteingang auf den Bestätigungscode.',
        userGroupsTitle: 'Benutzergruppen',
        userGroupsFillPlaceholder: 'Geben Sie den Namen einer Gruppe ein ...',
        userHistory: 'Benutzerverfolgung {Benutzer}',
        userIsActive: 'Aktiv?',
        userLastName: 'Nachname',
        userLogin: 'Einloggen',
        userLoginAction: 'Einloggen',
        userLoginEmailSelected: 'Verbindung mit E-Mail-Adresse: {email}',
        userLoginError: 'Falsche Anmeldeinformationen! Versuchen Sie es noch einmal...',
        userLoginFirstButton: 'Erstes einloggen?',
        userLoginFirstText: 'Überprüfen Sie Ihre Mailbox auf Ihr temporäres Passwort. Verwenden Sie dieses Passwort für Ihre erste Verbindung. Sie können dann Ihr Passwort ändern.',
        userLoginIntro: 'Bitte identifizieren Sie sich, um auf Ihren persönlichen Bereich zuzugreifen.',
        userLoginNoConnexion: 'Keine Verbindung',
        userLoginTitle: 'Einloggen',
        userLogout: 'Ausloggen',
        userName: 'Nachname',
        userNewPassword: 'Neues Passwort',
        userOldPassword: 'Altes Passwort',
        userOptions: 'Benutzeroptionen',
        userPassword: 'Passwort',
        userPasswordConfirmation: 'Passwort Bestätigung',
        userPasswordConfirmationError: 'Bitte geben Sie eine mit dem Passwort identische Bestätigung ein!',
        userPasswordConfirmationRestriction: 'Die Bestätigung muss mit dem eingegebenen Passwort identisch sein',
        userPasswordDisplayButton: 'Passwort anzeigen',
        userPasswordEdit: 'Ändere mein Passwort',
        userPasswordError: 'Bitte geben Sie ein korrektes Passwort ein!',
        userPasswordHideButton: 'Passwort verbergen',
        userPasswordResetText: 'Bitte geben Sie Ihr persönliches Passwort ein. Bestätigen Sie es und klicken Sie auf die Schaltfläche unten.',
        userPasswordRestriction: 'Das Passwort muss 6 Zeichen enthalten!',
        userPasswordRestrictionAlt: 'Das Passwort muss 6 Zeichen enthalten!',
        userPasswordTemporaryCheckButton: 'Ich habe mein vorläufiges Passwort erhalten',
        userPhone: 'Telefon',
        userProfileMy: 'Mein Profil',
        userRegister: 'Erstelle mein Konto',
        userReInitPassword: 'Mein Passwort erneuern',
        userRegisterError: 'Ihr Konto kann nicht erstellt werden! Bitte überprüfen Sie Ihre E-Mail-Adresse und versuchen Sie es erneut ...',
        userRegisterSuccess: 'Herzliche Glückwünsche! Ihr Konto wurde erstellt!',
        userResetPasswordAccountButton: 'Konto Passwort erneuern',
        userResetPasswordError: 'Passwort kann nicht erneuert werden! Bitte versuch es später ...',
        userResetPasswordInfo: 'Sie erhalten einen Code in Ihrer Mailbox, um Ihr Passwort zu erneuern.',
        userResetPasswordInfo2: 'Erneuern Sie Ihr Passwort, indem Sie die folgenden Felder ausfüllen:',
        userResetPasswordSuccess: 'Passwort erfolgreich erneuert!',
        userRole: 'Rolle',
        userRoleCustomer: 'Kunde',
        userRoleAdmin: 'Administrator',
        users: 'Benutzer',
        userSearchLabel: 'Geben Sie eine E-Mail oder einen Benutzernamen ein',
        userSelectPlaceholder: 'Wählen Sie einen Benutzer aus',
        userSendNewAccountEmail: 'Senden Sie ein neues Konto per E-Mail an den Benutzer',
        userSendNewAccountEmailSuccess: 'Informierter Benutzer!',
        usersList: 'Benutzerliste',
        userSubscribeNewsletterLabel: 'Ich möchte personalisierte Angebote von Atremoplus® erhalten',
        userSwitch: 'Benutzer wechseln',
        userValidForgotPasswordError: 'Der Code zum Erneuern des Passworts kann nicht gesendet werden!',
        userValidForgotPasswordSuccess: 'Überprüfen Sie Ihren E-Mail-Posteingang, um Ihren Bestätigungscode zum Erneuern Ihres Passworts zu verwenden!',
        valid: 'Bestätigen',
        view: 'Sehen',
        voucher: 'Rabattcode',
        voucherCodePlaceholder: 'Geben Sie Ihren Gutscheincode ein',
        voucherNotExistsError: 'Dieser Promo-Code existiert nicht!',
        voucherNotValidError: 'Dieser Gutschein kann nicht auf Ihre Bestellung angewendet werden!',
        vouchers: 'Ermäßigungen',
        yes: 'Ja',
        You: 'Sie',
        yourself: 'Sie',
    },
};
